// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
// @end

class SurveyService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  remove = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/survey/delete/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  generateReport = async (data: {startDate: string, endDate: string}) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/survey/general-survey-report`,
      auth_token: this.token,
      params: {...data}
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getAvailableUserSurveys = async () => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/event/survey/get-available-user-surveys`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getAvailableUserSurveysByScheduling = async (schedulingId: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/event/survey/get-available-user-surveys-by-service/${schedulingId}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData;
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }
}

export default SurveyService
